<template>
    <v-container grid-list-xl fluid>
      <CustomizationSelector title="" :value="item.name" :options="accessoriesOptions" v-on:selected-option="item.name = $event, getPrice(), item.tubeType = null " :v="$v.item.name" :error="$v.item.name.$error"></CustomizationSelector>
      <v-select v-if="['Somfy Sonesse 30 2.0nm'].includes(item.name)" :items="tubes" v-model="item.tubeType" label="Tube Type"></v-select>
      <v-text-field type="number" min="1" v-model="item.quantity" label="Quantity" @input="item.total = item.quantity * item.itemPrice"></v-text-field>
      <v-text-field v-model="item.itemPrice" label="Item Price" readonly></v-text-field>
      <v-text-field v-model="item.total" label="Total" readonly></v-text-field>
      <v-textarea name="notes" label="Item Notes" v-model="item.notes"></v-textarea>
      <v-btn v-if="!edit" @click="addItem()" color="primary">Add {{ item.type }}</v-btn>
      <v-btn v-else @click="addItem()" color="primary">Update {{ item.type }}</v-btn>
      <b>${{ (item.total).toFixed(2) }}</b>
    </v-container>
</template>

<script>
import ItemService from '@/services/ItemService.js'
import CustomizationSelector from '@/components/parts/CustomizationSelector'
import { required } from 'vuelidate/lib/validators'

// const gConfig = require('../../../gConfig.json')

export default {
  props: {
    edittingItem: {
      default: null
    },
    editChange: {
      default: null
    }
  },
  components: {
    CustomizationSelector
  },
  data () {
    return {
      item: {
        type: 'Motor Accessories',
        orderID: null,
        name: null,
        itemPrice: 0,
        total: 0,
        notes: null,
        quantity: 1,
        ordering: 1000
      },
      edit: false,
      readyToSubmitDimension: false,
      accessoriesOptions: [
        'Somfy Altus 28 1.5nm',
        'Somfy Sonesse 30 2.0nm',
        'Somfy Connexoon',
        'Somfy Motor Charger',
        'Irismo 45 Li-ion Charger',
        'Situo Pure 1 channel Remote',
        'Situo Pure 5 channel Remote',
        'Telis 16 channel Remote',
        'Bond Bridge'
      ],
      accessoriesPrice: {
        'Somfy Altus 28 1.5nm': 210,
        'Somfy Sonesse 30 2.0nm': 295,
        'Somfy Connexoon': 299,
        'Somfy Motor Charger': 25,
        'Irismo 45 Li-ion Charger': 70,
        'Situo Pure 1 channel Remote': 65,
        'Situo Pure 5 channel Remote': 100,
        'Telis 16 channel Remote': 329,
        'Bond Bridge': 195
      },
      tubes: [
        'DIY Blinds',
        'Hunter Douglas 37mm',
        'Hunter Douglas 50mm',
        'Louvolite 40mm',
        'Rollease Acmeda S40 Heavy Duty 32mm',
        'Rollease Acmeda S45 Light 38mm',
        'Rollease Acmeda S45 Standard 38mm',
        'Rollease Acmeda S45 Heavy Duty 38mm'
      ]
    }
  },
  validations: {
    item: {
      name: { required }
    }
  },
  watch: {
    edittingItem (item) {
      this.useEdittingItem(item)
    }
  },
  mounted () {
    this.useEdittingItem(this.edittingItem)
  },
  methods: {
    makeItem (event) {
      this.item.name = event
      this.item.itemPrice = this.accessoriesPrice[event]
      this.item.total = this.item.itemPrice * this.item.quantity
    },
    useEdittingItem (item) {
      if (!this.editChange) {
        if (item) {
          this.edit = true
          this.item = item
        }
      } else {
        this.item = {
          orderID: item.orderID,
          type: 'Motor Accessories',
          name: null,
          itemPrice: 0,
          total: 0,
          quantity: 1,
          ordering: 1000,
          notes: null
        }
        if (item && item._id) {
          this.item._id = item._id
        }
        this.item.orderID = item.orderID
      }
    },

    addItem () {
      this.$v.item.$touch()
      if (this.$v.item.$pending || this.$v.item.$error) return

      this.edit = false
      this.$emit('create-item', this.item)
    },
    async getPrice () {
      const response = await ItemService.getPricing(this.item)
      console.log(this.item)
      if (response.data.price) {
        this.item.itemPrice = response.data.itemPrice
        this.item.total = response.data.total
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/MotorAccessories.vue